<pc-dialog-abstract [isMobile]="!isDesktop()" [size]="isDesktop() ? 'md' : inputMobileSize()" (closeDialog)="close()">
  <div class="error-popup {{ contentClass }}" content>
    <header>
      <h1 [id]="ariaLabelledBy()">{{ title }}</h1>
      @if (isCloseIcon()) {
        <button class="close-btn" tabindex="0" [ariaLabel]="closePopUpAriaLabel()" (click)="close()">
          <pc-icon class="x-icon" [icon]="xicon" [size]="iconSize"></pc-icon>
        </button>
      }
    </header>
    <div class="separator-wrapper">
      <pc-separator></pc-separator>
    </div>
    <img class="desktop-main-image" [alt]="imgAlt" [src]="desktopImgPath" />

    <section #scrollableSection class="section-content" cdkScrollable>
      <img class="mobile-main-image" [alt]="imgAlt" [src]="mobileImgPath" />
      @if (activeSection()) {
        <main class="main">
          <section class="section">
            @if (description) {
              <h3 class="description">{{ description }}</h3>
            }
            @if (information) {
              <p class="information" [innerHTML]="information"></p>
            }
            @if (subInformation()) {
              <br />
              <p class="sub-information" [innerHtml]="subInformation()"></p>
            }
          </section>
        </main>
      }
      <div #projectedContentWrapper>
        <ng-content select="[section-content]"></ng-content>
      </div>
      @if (isButtonsPartOfScrollingContainer()) {
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      }
    </section>
    @if (!isButtonsPartOfScrollingContainer()) {
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    }
    @if (enableFadeOverlay()) {
      <div class="fade-overlay" [class.is-active]="shouldDisplayFadeOverlay()"></div>
    }
  </div>
</pc-dialog-abstract>

<ng-template #footer>
  <footer>
    <div class="action-buttons {{ buttonsContainerFlexDirection() }}">
      @if (buttonText) {
        <pc-gradient-btn
          class="button"
          buttonType="primary"
          [attr.aria-label]="buttonText"
          [btnMinWidth]="btnMinWidth"
          [btnPadding]="btnPadding()"
          [icon]="submitButtonIcon()"
          [isDisabled]="submitDisabled().value"
          [isLoading]="isButtonLoader()"
          [text]="buttonText"
          (btnClicked)="closeSubmit()"
        ></pc-gradient-btn>
      }
      @if (buttonTextSecondary || buttonSecondaryInnerHtmlText) {
        <pc-gradient-btn
          class="button-secondary"
          [attr.aria-label]="buttonTextSecondary"
          [btnMinWidth]="secondaryBtnMinWidth()"
          [btnPadding]="secondaryBtnPadding()"
          [buttonType]="secondaryButtonType()"
          [icon]="secondaryButtonIcon()"
          [innerHtmlButtonText]="buttonSecondaryInnerHtmlText"
          [isAnimated]="secondaryButtonAnimation()"
          [isDisabled]="submitSecondaryDisabled().value"
          [isLoading]="isButtonLoaderSecondary()"
          [isTextImageReverseOrder]="isSecondaryBtnTextImageReverseOrder()"
          [text]="buttonTextSecondary"
          (btnClicked)="closeSubmitSecondary()"
        ></pc-gradient-btn>
      }
    </div>
    @if (transparentButtonText()) {
      <button pcButton [color]="'link-transparent'" [size]="'xsmall'" (click)="onAlternativeButton()">
        <span class="btn-edit body-large" [attr.aria-label]="ariaLabelText()">{{ transparentButtonText() }}</span>
      </button>
    }
  </footer>
</ng-template>
